
export const getClaimHomeData = () => {
    return (dispatch, getState) => {
        const order_id = getState().app.tourId;
        const cr = encodeURIComponent(document.location.origin);
        const mode = getState().app.tourType;
        const url = getState().claimHome.url;
        // window.location.href = `${url}${order_id}/${cr}/${mode}`;
        window.open(`${url}${order_id}/${cr}/${mode}`, '_blank', 'toolbar=yes, location=yes, status=yes, menubar=yes, scrollbars=yes');
    }
}
